"use client";

import React from "react";
import { User, Package, Calendar, Star, PenLine, Search } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * WebsiteForCoachesAndConsultants — Section 4: 6 Coach-Features
 * Drop-in für: src/pages/WebsiteForCoachesAndConsultants/sections/OurPromise.tsx
 */

const features = [{
  icon: User,
  title: "Über mich Seite",
  description: "Erzählen Sie Ihre Geschichte. Qualifikationen, Erfahrung, Philosophie — alles an einem Ort. Persönlich und authentisch."
}, {
  icon: Package,
  title: "Angebote & Pakete",
  description: "Stellen Sie Ihre Coaching-Pakete, Einzel-Sessions oder Workshops übersichtlich dar — mit Preisen und Beschreibungen."
}, {
  icon: Calendar,
  title: "Termin-Integration",
  description: "Verlinken Sie Calendly, Google Calendar oder ein einfaches Kontaktformular. Klienten buchen direkt — ohne Telefon-Ping-Pong."
}, {
  icon: Star,
  title: "Testimonials",
  description: "Zeigen Sie Kundenstimmen und Erfolgsgeschichten. Nichts überzeugt mehr als die Erfahrungen anderer Klienten."
}, {
  icon: PenLine,
  title: "Blog / Insights",
  description: "Teilen Sie Ihr Wissen in Blogbeiträgen. Positionieren Sie sich als Experte und werden Sie über Google gefunden."
}, {
  icon: Search,
  title: "SEO für Coaches",
  description: 'Lokale SEO für „Business Coach Zürich" oder „Ernährungsberatung Bern" — die KI optimiert Ihre Texte automatisch.'
}];
export default function OurPromise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-background py-20 md:py-24">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-14 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Was Ihre Coach-Website kann
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Speziell für Berater, Therapeuten und Coaches entwickelt.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => <div key={i} className="group bg-card border border-border rounded-xl p-7 hover:border-primary/40 hover:shadow-xl transition-all duration-300">
              <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white transition-colors">
                <f.icon className="w-6 h-6" strokeWidth={1.5} />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-2 tracking-tight">
                {f.title}
              </h3>
              <p className="text-base leading-relaxed text-muted-foreground">
                {f.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}